import { ColumnType } from "components/AgGrid/constants";

import { getters } from "lib/agGrid";

export const RuleSetColId = {
  CREATED: "4b9ebbcf-18e5-47ff-9978-c1c6f4f598ad",
  LAST_MODIFIED: "8e65ed70-3f52-40ec-ab50-69feadd2bc80",
  NAME: "978e5dc3-4f0c-4fb9-9b18-51bdc9359693",
  INPUT_FIELD: "69523b88-4a8f-4239-bb31-80dc56be1aae",
};

export const RuleSetColumnDefinitions = {
  [RuleSetColId.NAME]: {
    colId: RuleSetColId.NAME,
    field: "ruleSet.name",
    headerName: "Name",
    width: 90,
    type: ColumnType.STRING,
    enableRowGroup: true,
  },
  [RuleSetColId.CREATED]: {
    colId: RuleSetColId.CREATED,
    field: "ruleSet.created",
    headerName: "Created",
    width: 90,
    type: ColumnType.UTC_LOCAL_DATE_TIME,
  },
  [RuleSetColId.LAST_MODIFIED]: {
    colId: RuleSetColId.LAST_MODIFIED,
    field: "ruleSet.last_modified",
    headerName: "Last Modified",
    width: 90,
    type: ColumnType.UTC_LOCAL_DATE_TIME,
  },
  [RuleSetColId.INPUT_FIELD]: {
    colId: RuleSetColId.INPUT_FIELD,
    field: "ruleSet.input_field",
    headerName: "Based On",
    width: 90,
    type: ColumnType.STRING,
    valueGetter: getters.ruleInputField,
  },
};
